import React from 'react'
import orgamax from 'ampersand-app'
import PropTypes from 'prop-types'

import lang from '@/lang'
import styles from './logout-button.css'
import { useDispatch } from 'react-redux'
import { userLoggedOut } from '@/redux/ducks/global'

const LogoutButton = (props) => {
  const { disabled = false, customClass, dataQsId, onClick } = props
  const dispatch = useDispatch()

  const disabledClass = disabled ? styles.disabled : ''
  const onLogoutClicked = () => {
    dispatch(userLoggedOut())
    orgamax.user.logout(true)
    onClick && onClick()
  }

  return (
    <button
      data-qs-id={dataQsId}
      type='button'
      {...props}
      className={`${styles.button} ${disabledClass} ${customClass || ''}`}
      onClick={onLogoutClicked}>
      {lang.logoutButtonLabel}
    </button>
  )
}

LogoutButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  customClass: PropTypes.string,
  dataQsId: PropTypes.string.isRequired,
}

export default LogoutButton
